import InputsAggregatedDotBadge from "components/inputs/InputsAggregatedDotBadge";
import Routes from "routing/Routes";
import filterMenuItems, { filterCloudMenuItems } from "util/conditional/filterMenuItems";
import AppConfig from "util/AppConfig";
import DocsHelper from "util/DocsHelper";
export const SYSTEM_DROPDOWN_TITLE = "\u7CFB\u7EDF";
export const SEARCH_LINK_TITLE = "\u641C\u7D22";
export const DASHBOARDS_LINK_TITLE = "\u4EEA\u8868\u76D8";
const navigationBindings = {
  navigation: [
    {
      path: Routes.SEARCH,
      description: SEARCH_LINK_TITLE
    },
    {
      path: Routes.STREAMS,
      description: "\u65E5\u5FD7\u6D41"
    },
    {
      path: Routes.DASHBOARDS,
      description: DASHBOARDS_LINK_TITLE
    },
    {
      description: SYSTEM_DROPDOWN_TITLE,
      BadgeComponent: InputsAggregatedDotBadge,
      position: { last: true },
      children: filterCloudMenuItems(
        filterMenuItems(
          [
            {
              path: Routes.SYSTEM.INPUTS,
              description: "\u8F93\u5165",
              permissions: ["inputs:read"],
              BadgeComponent: InputsAggregatedDotBadge
            },
            { path: Routes.SYSTEM.INDICES.LIST, description: "\u7D22\u5F15", permissions: ["indices:read"] },
            { path: Routes.SYSTEM.USERS.OVERVIEW, description: "\u7528\u6237" }
          ],
          AppConfig.isCloud() && !AppConfig.isFeatureEnabled("cloud_inputs") ? [Routes.SYSTEM.INPUTS] : []
        ),
        []
      )
    }
  ],
  helpMenu: [
    { description: "Documentation", externalLink: DocsHelper.versionedDocsHomePage() },
    ...AppConfig.gl2DevMode() ? [{ description: "Design System", externalLink: "https://graylog2.github.io/design-system" }] : [],
    { description: "Keyboard Shortcuts", action: ({ showHotkeysModal }) => showHotkeysModal() },
    {
      description: "API browser",
      path: Routes.API_BROWSER,
      permissions: "api_browser:read"
    }
  ]
};
export default navigationBindings;
